import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'prDateFormat',
    standalone: false
})
export class PrDateFormatPipe implements PipeTransform {
  transform(value) {
    let years = Math.floor(value / 12);
    let months = value - years * 12;

    let transform = `${years} ans`;
    if (years == 0) transform = `${months} mois`;
    else if (years > 0 && months > 0)
      transform = transform.concat(`, ${months} mois`);
    return transform;
  }
}
